import { useParams } from 'react-router-dom'
import { useState, useEffect}  from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { MdArrowBackIosNew } from 'react-icons/md'  
import styled, { keyframes } from 'styled-components';
import Loader from 'loaders/Loader' 
import { MdPendingActions } from "react-icons/md"; 
import toast, { Toaster } from 'react-hot-toast';
import { PiShieldCheck, PiSealCheckFill  } from "react-icons/pi";  
import { 
    SinglePageContainer, SinglePageWrap, SinglePageLeft, SinglePageRight,
      RightMainContent, TopRightItemContainer, SectionButton, SectionBtn
} from 'pages/pages.styled'
import { endQASession, getQASession, getQuestions, setStatusFilter, resetQuestions, setQuestionSortValue } from 'features/qaSessions/qaSessionSlice'
import AskAQuestionInput from 'components/qaSessions/AskAQuestionInput'
import SessionSettings from 'components/qaSessions/SessionSettings' 
import SpinnerSmall from 'components/SpinnerSmall'
import EndSessionDetails from 'components/qaSessions/EndSessionDetails'
import { Modal } from '@mui/material'
import ConfirmModal from 'components/modals/ConfirmModal'
import { setViewConfirmModal } from 'features/modal/modalSlice'
import ExpirationTimer from 'components/utils/ExpirationTimer'
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import QuestionsFeed from 'components/qaSessions/QuestionsFeed'
import { pBtnSmall } from 'components/main.styled'
import { MdOutlineSort } from "react-icons/md";
import { useTranslation } from 'react-i18next'

export default function SingleEventPage(props) {

    const { t } = useTranslation('qna')

    const statusColor = {
        "pending": "#cccccc",
        "approved": "#2f6a24", 
        "rejected": "#834848",
        "answered": "#28539d"
    }

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { sortQuestionsBy, addQuestionStatus, errorValue, myQuestions, questions, sessionData, getQASessionStatus, getQuestionsStatus, statusFilter, endQASessionStatus } =  useSelector((state) => state.qASession)  
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { sessionId } = useParams() 
    const [ viewRightSide, setViewRightSide ] = useState(false)
    const { viewConfirmModal, confirmModalData } = useSelector((state) => state.modal)

    const handleSort = (value) => {
        dispatch(setQuestionSortValue(value))
        dispatch(getQuestions({
            sessionId: sessionId,
            status: statusFilter,
            sortValue: value,
            churchId: profileChurch._id
        }))
    }

    const handleEndSession = () => {
        dispatch(endQASession({
            sessionId: sessionId
        }))
    }

    useEffect(() => {
        if(endQASessionStatus === "SUCCESS"){
            navigate(-1)
        }
    }, [endQASessionStatus])

    const handleContentView = (value) => { 
        dispatch(setStatusFilter(value)) 
        if(sessionData.isReady){
            dispatch(getQuestions({
                sessionId: sessionId,
                status: value,
                sortValue: sortQuestionsBy,
                churchId: profileChurch._id
            }))
        }
    }

    useEffect(() => {
        if(addQuestionStatus === "ERROR"){
            toast.error(errorValue)
        }
    }, [addQuestionStatus])

 

    useEffect(() => {
        dispatch(getQASession({
            sessionId: sessionId
        }))
    }, [])

    useEffect(() => { 
        if(sessionData.isReady){  
            if(sessionData.questionVisibility === "public"){
                setViewRightSide(true) 
            }else if(sessionData.questionVisibility === "private"){ 
                if(user.isOrganization){ 
                    setViewRightSide(true)
                    return
                }else if(user.isAdmin){ 
                    setViewRightSide(true)
                    return
                }  
            } 
        } 
    }, [sessionData.isReady, sessionData.questionVisibility])

    const handleClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        return () => {
            dispatch(resetQuestions())
        }
    }, [])

    return (
        <SinglePageContainer>
            <Toaster />
            { user && ( <div className='singlePostPostedToWrap'> <div className='singlePostGoBack' onClick={handleClick} >  <MdArrowBackIosNew style={{marginRight: '10px'}} /> {t('navigation.back')}  </div> </div> )}
   
            {
                sessionData.isReady && 
                (
                    getQASessionStatus === "LOADING" ? (
                        <Loader />
                    )
                    :
                    (
                        <SinglePageWrap addTopMargin={!user} style={{ maxWidth: !viewRightSide && "800px" }}  >
                            <SinglePageLeft fullWidth={!viewRightSide} > 
                                <EventInfo> 
                                    <ChurchInfo>
                                        <ChurchImage>
                                            {
                                                sessionData.church.profileImg && 
                                                (
                                                    <img 
                                                        onContextMenu={(e) => e.preventDefault()}
                                                        src={`${sessionData.church.profileImg.url}`} alt='event' 
                                                        style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}} 
                                                        />
                                                ) 
                                            }

                                        </ChurchImage>
                                        <ChurchName>{profileChurch.fullName}</ChurchName>
                                    </ChurchInfo> 
                                    <EventInfoWrap>
                                        <EventTitle> <p style={{marginLeft: "10px"}}>{sessionData.title}</p> </EventTitle> 
                                        {
                                            sessionData.status === "closed" ?
                                            
                                            (
                                                <ClosedContainer>Closed</ClosedContainer>
                                            )
                                            : sessionData.status === "active" &&
                                            (
                                                <span style={{
                                                    width: "fit-content", display: "flex", flexDirection: "column",alignItems: "center", justifyContent: "flex-end"
                                                }}>
                                                    <PulseContainer> 
                                                        <PulseButton> Active </PulseButton> 
                                                    </PulseContainer>      
                                                    {
                                                        sessionData.expiresAt && (
                                                            <ExpirationTimer expiration={sessionData.expiresAt} />   
                                                        )
                                                    }
                                                                                       
                                                </span>

                                            )
                                        }
                                        
                                    </EventInfoWrap> 
                                </EventInfo>
 
                                {   
                                    user.isOrganization  ?
                                    ( 
                                        <SessionDataWrap>  
                                            {
                                                user.isAdmin &&
                                                <AskAQuestionInput />
                                            } 
                                            
                                            <SessionSettings sessionData={sessionData} /> 
                                            <EndSessionDetails  
                                                expirationDate={sessionData.expiresAt} 
                                                /> 
                                        </SessionDataWrap>
                                    )
                                    :
                                    (
                                        <AskAQuestionInput />
                                    )
                                }

                                {   !user.isOrganization &&
                                    ( 
                                        <RightMainContent 
                                            style={{ gap: "20px", paddingRight: "11px", width: "100%", alignItems: "flex-start", justifyContent: "flex-start",
                                                maxHeight:"400px", overflowY: "scroll", backgroundColor: "transparent"}}>
                                            <div style={{color: "#8d8d8d"}}>{t('questions.mine')}</div>
                                            {
                                                myQuestions.length > 0 &&
                                                myQuestions.map((question) => (
                                                    <MyQuestionItem>
                                                        <MQIT>
                                                            <div style={{color: "#959595", display: "flex", gap: "10px"}}>
                                                                <span>{question.isAnonymous ? "Anonymous": question.creator.fullName}</span>
                                                                <span> <TimeAgo datetime={new Date(question.createdAt)}/>  </span>
                                                            </div>  
                                                            <QStatus color={statusColor[question.status]}> {t(`statuses.${question.status}`, { defaultValue: question.status })} </QStatus>
                                                        </MQIT>
                                                        <p>{ question.text }</p> 
                                                        <MQIT>
                                                            
                                                        </MQIT>
                                                    </MyQuestionItem>
                                                ))
                                            }
                                        </RightMainContent>
                                    )
                                } 
                            </SinglePageLeft>
 
                            { viewRightSide && 
                                (
                                    <SinglePageRight>
                                        <TopRightItemContainer style={{flexDirection: "column", alignItems: "flex-start"}}>
                                            {   
                                                (user.isOrganization || user.isAdmin) &&
                                                (
                                                    <SectionButton style={{width: "100%", alignItems: "flex-start"}}>
                                                        <SectionBtn
                                                            active={statusFilter === 'pending'} 
                                                            onClick={() => handleContentView('pending')}
                                                            >
                                                            <MdPendingActions size={18} />
                                                            <span>Pending</span>
                                                        </SectionBtn>                                                         
                                                        <SectionBtn 
                                                            active={statusFilter === 'approved'} 
                                                            onClick={() => handleContentView('approved')}
                                                            >
                                                            <PiShieldCheck size={18}  />
                                                            <span>Approved</span>
                                                        </SectionBtn>

                                                        <SectionBtn
                                                            active={statusFilter === 'answered'} 
                                                            onClick={() => handleContentView('answered')}
                                                            >
                                                            <PiSealCheckFill color="green" size={18} />
                                                            <span>Answered</span>
                                                        </SectionBtn> 
                                                    </SectionButton> 
                                                )  
                                            }
                                            {
                                                statusFilter === "approved" && (
                                                    <ApprovedFilterWrap>
                                                        <MdOutlineSort color={"#6d6d6d"} size={18} />
                                                        <SortBtn1 
                                                            style={{width: "100px"}}
                                                            onClick={() => handleSort("mostUpvoted")}
                                                            active={sortQuestionsBy === "mostUpvoted"}>
                                                            {t('questions.mostUpvoted')}
                                                        </SortBtn1>
                                                        <SortBtn1
                                                            onClick={() => handleSort("newest")}
                                                            style={{width: "70px"}}
                                                            active={sortQuestionsBy === "newest"}
                                                            >
                                                            Date
                                                        </SortBtn1>
                                                    </ApprovedFilterWrap>
                                                )
                                            }
                                        </TopRightItemContainer> 

                                        {
                                            getQASessionStatus === "LOADING" ?
                                            (
                                                <QuestionsContainer1>
                                                    <SpinnerSmall border='#5a5a5a' />
                                                </QuestionsContainer1>
                                            )
                                            :
                                            (
                                                // <span>ddd</span>
                                                <QuestionsFeed />
                                            )
                                        }
                                        
                                            
                                    </SinglePageRight> 
                                ) 
                        }  
                        </SinglePageWrap>
                    )
                )
            } 
            <Modal
                open={viewConfirmModal}
                onClose={() => dispatch(setViewConfirmModal(false))}
                aria-labelledby="modal-modal-title"
                >
                <ModalWrapper1>
                    <ConfirmModal 
                        text={"End session"} 
                        handler={handleEndSession} 
                        confirmBtnBackgroundHover={"red"}
                        extraInfo={"This action cannot be undone"}
                        conditionToCloseModal={endQASessionStatus === "SUCCESS"}

                        />                
                </ModalWrapper1> 
            </Modal>

        </SinglePageContainer>
    )
}

const SortBtn1 = styled(pBtnSmall)`
    font-size: 11px; 
    border: ${props => props.active ? "1px solid #cdebd5":"1px solid #e1e7eb"};
    background-color: ${props => props.active ? "#eef9f1" : "#f2f6f8"};
    color: ${props => props.active ? "#168236" : "#626b70"};
    border-radius: 7px;
    font-weight: 700;

    &:hover{
        background-color: ${props => props.active ? "#e6f6eb" : "#eef1f3"};
    }
`

const ApprovedFilterWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start; 
    gap: 10px;
    margin-top: 10px;
`

const MQIT = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const ModalWrapper1 = styled.div`   
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const MyQuestionItem = styled.div`
    padding: 16px;
    width: 100%;
    display: flex;
    flex-direction: column; 
    background-color: white;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    border-radius: 8px;
    justify-content: flex-start;
    align-items: flex-start;
    p{
        width: 100%;
        text-align: left;
        margin-top: 5px;
        color: #646464;
        line-height: 1.5;
    }
`

const QStatus = styled.div`
    color: ${props => props.color};
    min-width: 75px;
    height: 25px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;  
    background-color: #f2f6f8;
    border: 1px solid #e1e7eb;
    border-radius: 6px;
    font-weight: 700;
    text-transform: capitalize;
`

 

const QuestionsContainer1 = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px; 
    padding-top: 20px;
    min-height: 400px;
`

// Keyframe animation for pulsing
const pulse = keyframes`
  0% {
    transform: scale(0.9);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(90, 153, 212, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
`;

const ClosedContainer = styled.div`
  display: inline-block;
  padding: 8px 16px;
  font-size: 0.9em;
  outline: none;
  font-weight: 500;
  color: #9c3a31;
  background: #f7ebe9;
  border: 1px solid #f1d4d0;
  border-radius: 7px;
  cursor: pointer;

  &:hover {
    animation: none;
  }
`

export const PulseContainer = styled.div`
  width: fit-content;
  height: 45px; 
  /* perspective: 100px; */
  backface-visibility: hidden;
  background: transparent;
  display: flex;
  flex-direction: row; 
  align-items: center;
  justify-content: center;
`;

export const PulseButton = styled.button`
  display: inline-block;
  padding: 8px 16px;
  font-size: 0.9em;
  outline: none;
  font-weight: 700;
  color: #168236;
  background: #eef9f1;
  border: 1px solid #cdebd5;
  border-radius: 7px;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(33, 173, 70, 0.22);
  animation: ${pulse} 1.5s infinite;

  &:hover {
    animation: none;
  }
`;

const SessionDataWrap = styled.div`
    display: flex;
    flex-direction: column;
    
    width: 100%;
    height: fit-content;  

    @media (max-width: 768px) {
        margin-top: 10px;
    }


`
  
const EventInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    padding: 12px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    @media (max-width: 768px) {
        padding: 10px;
        height: 100%;
    }
`
const EventInfoWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    height: fit-content;
    padding: 10px;

    @media (max-width: 768px) {
        padding: 0px;
    }
`

const ChurchInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: fit-content;
    padding: 10px;
    border-bottom: 1px solid #edf0f2;
    @media (max-width: 768px) {
        padding: 10px; 
    }
`
const ChurchImage = styled.div`
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid #eef1f3;
    overflow: hidden;
`
const ChurchName = styled.div`
    font-size: 15px;
    color: var(--lightThemeSecondaryFontColor);
    font-weight: 500;
    padding: 10px;
    @media (max-width: 768px) {
        padding-left: 10px;
    }
`

const EventTitle = styled.div`
    font-size: 18px;
    color: var(--lightThemeFontColor);
    font-weight: 700;
    display: flex;
    flex-direction: row;
    align-items: center;
    @media (max-width: 768px) {
        margin-top: 10px;
    }
`
